import { render, staticRenderFns } from "./auth-seekers.vue?vue&type=template&id=0d54b4f9"
import script from "./auth-seekers.vue?vue&type=script&lang=js"
export * from "./auth-seekers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports